import React from 'react'
import ReactModal from 'react-modal'
import styled from '@emotion/styled'
import { ModalComponent } from './ModalContext'
import './modalOverlay.css'

export interface ModalEntry {
  id: string
  component: ModalComponent
}

export interface ModalOverlayProps {
  modals: ModalEntry[]
  onCloseModal: (id: string, result?: any) => unknown
}

export const ModalItem = styled.div<{ topmost: boolean }>`
  pointer-events: ${props => (props.topmost ? 'all' : 'none')};
`

export class ModalOverlay extends React.PureComponent<ModalOverlayProps> {
  render() {
    const { modals, onCloseModal } = this.props

    if (modals.length === 0) {
      return null
    } else {
      const modalItems = modals
        .map((modal, index) => (
          <ModalItem key={modal.id} topmost={index === 0}>
            {modal.component}
          </ModalItem>
        ))
        .reverse()

      return (
        <ReactModal
          ariaHideApp={false}
          isOpen={true}
          overlayClassName="modal-overlay"
          className="modal-overlay-content"
          shouldCloseOnEsc={true}
          shouldCloseOnOverlayClick={false}
          onRequestClose={() => onCloseModal(modals[0].id)}>
          {modalItems}
        </ReactModal>
      )
    }
  }
}
